import React, { Component } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import "react-confirm-alert/src/react-confirm-alert.css";
import v from "voca";
import InfoItem from "~app/models/info-item";
import { Button, Icon, Input, Popconfirm, Table } from "antd";
import Translatable from "~app/hoc/translatable";
import compose from "lodash/fp/compose";

const ButtonGroup = Button.Group;
const { Search } = Input;
const { Column } = Table;

class Index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            infoItems: [],
        };
        this.deleteInfoItem = this.deleteInfoItem.bind(this);
    }

    async componentDidMount() {
        this.setState({
            infoItems: await Index.getInfoItems(),
        });
    }

    static async getInfoItems(search) {
        const params = {};
        params.search = search;
        const result = await axios.get("/api/v1/infoitems", { params });
        return result.data.map(r => new InfoItem(r));
    }

    async deleteInfoItem(infoItem) {
        await axios.delete("/api/v1/infoitems/" + infoItem.id);
        this.setState({
            infoItems: await Index.getInfoItems(),
        });
    }

    async search(search) {
        this.setState({
            infoItems: await Index.getInfoItems(search),
        });
    }

    render() {
        const { t, translation } = this.props;
        const { infoItems } = this.state;
        return (
            <>
                <Search placeholder={v.capitalize(t("info_item_search_plural"))} onSearch={this.search} onChange={e => this.search(e.target.value)} allowClear/>
                <Table dataSource={infoItems} rowKey={infoItem => infoItem.id}  className="mt20" pagination={{ pageSize: 20 }}>
                    <Column key="internal" title={v.titleCase(t("name_internal"))} render={infoItem => infoItem.internal || "-"}/>
                    <Column key="title" title={v.titleCase(t("title"))} render={infoItem => translation(infoItem.title)}/>
                    <Column key="actions" className="buttons-group" title={v.titleCase(t("action_plural"))} render={infoItem => <>
                        <Link to={{pathname: `/infoitems/${infoItem.id}`, state: {
                                infoItem,
                            },
                        }}>
                            <Button icon="edit"/>
                        </Link>
                        <Popconfirm title="Info Item verwijderen?" icon={<Icon type="delete" style={{ color: "red" }}/>} onConfirm={() => this.deleteInfoItem(infoItem)}>
                            <Button icon="delete"/>
                        </Popconfirm>
                    </>}/>
                </Table>
                <Link
                    to={{
                        pathname: "/infoitems/create",
                    }}
                >
                    <Button icon="plus">{v.titleCase(t("info_item_new"))} </Button>
                </Link>
            </>
        );
    }
}

export default compose(Translatable)(Index);
